






































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SubscriptionPackageItem } from "@/types/subscriptionPackage";
import { HttpService } from "@/services/api/httpService";
import axios, { AxiosError } from "axios";
import { ClientGrantType } from "@/types/client";

@Component
export default class ClientGrantTypeDashboard extends Vue {
  GrantTypeId: string = "";
  httpService = new HttpService<ClientGrantType>();
  responseArray = new Array<ClientGrantType>();
  showModal: boolean = false;
  clientId: any = "";
  removeData = new ClientGrantType();
  async getList() {
    let httpService = new HttpService<Array<ClientGrantType>>();
    const response = await httpService.getList(
      `clients/${this.clientId}/grant-types`
    );
    this.responseArray = response.data;
    this.$emit("finishedLoading", true);
  }

  @Watch("$route", { immediate: true }) onRouteChanged() {
    this.clientId = this.$route.params.id;
    this.getList();
  }

  edit(grantType: ClientGrantType) {
    this.$router.push({
      name: "clientGrantTypeEdit",
      params: {
        id: this.clientId,
        grantTypeId: grantType.id
      }
    });
  }

  confirmRemove(data: ClientGrantType) {
    this.showModal = true;
    this.removeData = data;
  }
  async remove(data: ClientGrantType) {
    const response = await this.httpService.deleteItem(
      `clients/${data.clientId}/grant-types`,
      data.id
    );

    this.responseArray = this.responseArray.filter(
      (item: ClientGrantType) => item.clientId != data.clientId,
      this.$notification.success(`${data.grantType} successfully removed!`)
    );

    this.showModal = false;
    this.getList();
  }
}
